import { Alarm } from "iconsax-react";

interface ReportedItemCardProps {
  name: string;
  reports: number;
  lastReported: string;
}

export const ReportedItemCard = ({
  name,
  reports,
  lastReported,
}: ReportedItemCardProps) => (
  <div className="flex items-start gap-1.5 pb-2 border-b border-dark-30 last:border-b-0">
    <div className="p-[3px] bg-dark-40 rounded-full flex justify-center mt-[5px]">
      <Alarm color="#FEFEFE" variant="Bold" className="w-4.5 h-4.5" />
    </div>
    <div className="flex flex-col flex-1 items-start gap-0.5">
      <h3 className="text-dark-text text-sm font-medium">{name}</h3>
      <span className="text-xsm text-dark-90 bg-dark-20 px-2 rounded-[3px]">
        <span className="font-bold text-dark-text">{reports}</span> reports
      </span>
      <span className="text-xsm text-dark-80">{lastReported}</span>
    </div>
  </div>
);
